import React from 'react';

// material components
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import StyledBadge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';

// custom components
import AlertsDrawer from './AlertsDrawer';
import withShipment from '../../withShipment';

// constants

// redux
import { alertEntriesSelector } from '../../redux/selectors/alerts';
import { userInfoSelector } from '../../redux/selectors/auth';
import {
  fetchAlerts,
  snoozeAlert,
  resolveAlert,
  deleteAllAlerts,
} from '../../redux/actions/alerts';
import PropTypes from 'prop-types';

import { tableSettingSelector } from '../../redux/selectors/account';
import { getTableSetting } from '../../redux/actions/account';
import { Tooltip } from '@mui/material';

// styling

class Alerts extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      alertDrawerOpen: false,
      alerts: [],
    };
  }

  handleAlertDrawerClose = () => {
    this.setState({
      alertDrawerOpen: false,
    });
  };

  parseAlertTimestamp = (ts) => {
    if (!ts) return 0;
    // Format: "MM\dd\yyyy h:mm a" or "MM/dd/yyyy h:mm a"
    const parts = ts.trim().split(/\s+/);
    const datePart = parts[0];
    const timePart = parts[1] || '00:00';
    const meridiem = (parts[2] || 'AM').toUpperCase();

    const [mm, dd, yyyy] = datePart.split(/[/\\]/);
    let [h, min] = timePart.split(':').map(Number);
    if (meridiem === 'PM' && h < 12) h += 12;
    if (meridiem === 'AM' && h === 12) h = 0;

    return new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd), h, min).getTime();
  };

  sortAlertsByLatest = (alerts) => {
    return [...alerts].sort((a, b) => this.parseAlertTimestamp(b.timestamp) - this.parseAlertTimestamp(a.timestamp));
  };

  componentDidMount() {
    this.props.getTableSetting({});

    this.props.fetchAlerts({
      locationId: this.props.userInfo.selectedLocationId,
    });

    this.setState({ alerts: this.sortAlertsByLatest(this.props.alertEntries) });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.alertEntries !== this.props.alertEntries ||
      prevProps.account !== this.props.account
    ) {
      this.removeSnoozedAlerts();
    }
  }

  removeSnoozedAlerts = () => {
    let snoozedAlertIds = this.props.account.snoozedAlerts
      ? this.props.account.snoozedAlerts.map((alert) => alert.alertId)
      : [];
    let unsnoozedAlerts = this.props.alertEntries.filter((alert) => {
      return !snoozedAlertIds.includes(alert.alertId);
    });

    this.setState({ alerts: this.sortAlertsByLatest(unsnoozedAlerts) });
  };

  toggleAlertDrawer = () => {
    this.setState({
      alertDrawerOpen: true,
    });
  };
  handleResolveAlert = (alertId, index) => {
    let data = {
      alertId: alertId,
      shippingTemplateChangedIndex: index,
      locationId: this.props.userInfo.selectedLocationId,
    };
    this.props.resolveAlert(data);
  };

  render() {
    return (
      <>
        <Tooltip title="Notifications">
          <IconButton
            style={{ marginRight: '4px' }}
            aria-label="alerts"
            onClick={this.toggleAlertDrawer}
          >
            <StyledBadge badgeContent={this.state.alerts.length} color="error" overlap="rectangular">
              <NotificationsActiveIcon
                color="secondary"
                style={{ fontSize: '30px' }}
              />
            </StyledBadge>
          </IconButton>
        </Tooltip>

        <AlertsDrawer
          alertDrawerOpen={this.state.alertDrawerOpen}
          handleAlertDrawerClose={this.handleAlertDrawerClose}
          alertEntries={this.state.alerts}
          noAlerts={this.state.alerts.length === 0}
          closeDrawer={this.handleAlertDrawerClose}
          snoozeAlert={this.props.snoozeAlert}
          resolveAlert={this.handleResolveAlert}
          removeSnoozedAlerts={this.removeSnoozedAlerts}
          user={this.props.userInfo}
          deleteAllAlert={this.props.deleteAllAlerts}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  alertEntries: alertEntriesSelector(state),
  userInfo: userInfoSelector(state),
  account: tableSettingSelector(state),
});

const actionCreators = {
  fetchAlerts,
  snoozeAlert,
  resolveAlert,
  getTableSetting,
  deleteAllAlerts,
};

Alerts.propTypes = {
  alertEntries: PropTypes.array,
  userInfo: PropTypes.object,
  account: PropTypes.object,
};

Alerts.defaultProps = {
  alertEntries: [],
  userInfo: {},
  account: {},
};

export default withShipment(
  {
    mapStateToProps,
    actionCreators,
  },
  Alerts
);
